/**
 * FDCart API — thin wrapper over Shopify Cart AJAX API.
 * Returns cart JSON from responses; updates FDCart store.
 */
(function (global) {
  'use strict';

  var store = global.FDCart;

  function jsonPost(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          var err = new Error(data.description || data.message || 'Cart request failed');
          err.status = res.status;
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  function getCart(force) {
    return store.fetchCart(force);
  }

  function changeLine(key, quantity, extras) {
    var body = { id: key, quantity: quantity };
    if (extras && typeof extras === 'object') {
      if (Object.prototype.hasOwnProperty.call(extras, 'selling_plan')) {
        body.selling_plan = extras.selling_plan;
      }
      if (extras.properties) {
        body.properties = extras.properties;
      }
    }
    return jsonPost('/cart/change.js', body).then(function (cart) {
      store.setCart(cart);
      return cart;
    });
  }

  function updateLines(updates) {
    return jsonPost('/cart/update.js', { updates: updates }).then(function (cart) {
      store.setCart(cart);
      return cart;
    });
  }

  function updateCart(payload) {
    return jsonPost('/cart/update.js', payload || {}).then(function (cart) {
      store.setCart(cart);
      return cart;
    });
  }

  function addItems(items) {
    if (typeof global.addToCart === 'function') {
      return global.addToCart({ items: items }).then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || 'Add failed');
          return getCart(true);
        });
      });
    }
    return jsonPost('/cart/add.js', { items: items }).then(function () {
      return getCart(true);
    });
  }

  function clearCart() {
    return jsonPost('/cart/clear.js', {}).then(function () {
      return jsonPost('/cart/update.js', { discount: '' }).then(function (cart) {
        store.setCart(cart);
        return cart;
      });
    });
  }

  function applyDiscounts(codes) {
    var list = [];
    var seen = {};
    (Array.isArray(codes) ? codes : []).forEach(function (raw) {
      var code = String(raw == null ? '' : raw).trim();
      if (!code) return;
      var key = code.toUpperCase();
      if (seen[key]) return;
      seen[key] = true;
      list.push(code);
    });
    if (!list.length) return getCart(false);
    return jsonPost('/cart/update.js', { discount: list.join(',') }).then(function (cart) {
      store.setCart(cart);
      return cart;
    });
  }

  var planUpgradeBackfillPromise = null;

  function copyLineProperties(properties) {
    var next = {};
    if (!properties || typeof properties !== 'object') return next;
    Object.keys(properties).forEach(function (key) {
      if (properties[key] != null) next[key] = properties[key];
    });
    return next;
  }

  function backfillPlanUpgrade(cart) {
    var ctx = global.FDCartContext;
    if (!ctx || typeof ctx.findPlanUpgradeSeed !== 'function') return Promise.resolve(cart);
    if (!cart || !Array.isArray(cart.items)) return Promise.resolve(cart);
    if (!ctx.findPlanUpgradeSeed(cart.items)) return Promise.resolve(cart);
    if (planUpgradeBackfillPromise) return planUpgradeBackfillPromise;

    var attempted = {};

    function step(current) {
      if (!current || !Array.isArray(current.items)) return current;
      var seed = ctx.findPlanUpgradeSeed(current.items);
      if (!seed) return current;
      var target = current.items.find(function (item) {
        return item && item.key && !attempted[item.key] && ctx.isEligibleForPlanUpgradeCopy(item, seed);
      });
      if (!target) return current;
      attempted[target.key] = true;
      var stamped = { properties: copyLineProperties(target.properties) };
      if (!ctx.copyPlanUpgradeProps(stamped, seed)) return current;
      var qty = Number(target.quantity);
      if (!Number.isFinite(qty)) return current;
      return changeLine(target.key, qty, { properties: stamped.properties }).then(step).catch(function (err) {
        console.warn('[FDCart] plan upgrade backfill failed', target.key, err);
        return current;
      });
    }

    planUpgradeBackfillPromise = Promise.resolve(cart).then(step).finally(function () {
      planUpgradeBackfillPromise = null;
    });
    return planUpgradeBackfillPromise;
  }

  global.FDCartApi = {
    getCart: getCart,
    changeLine: changeLine,
    updateLines: updateLines,
    updateCart: updateCart,
    addItems: addItems,
    applyDiscounts: applyDiscounts,
    backfillPlanUpgrade: backfillPlanUpgrade,
    clearCart: clearCart,
  };
})(typeof window !== 'undefined' ? window : this);
